import { get, isEmpty } from "lodash";

import axios from "../axios";
import { TOKENS } from "../constants/general.constants";
import { generalHelpers } from "../helpers";
import { userServices } from "../services";
import { showToaster } from "../helpers/toaster.helpers";

export const loginAction = async (payload, userOffline) => {
  // if (userOffline) {
  //   return;
  // }
  try {
    const response = await userServices.loginUser(payload);

    localStorage.setItem(
      TOKENS.REFRESH_TOKEN,
      get(response, "data.data.refresh_token", "")
    );

    localStorage.setItem(
      TOKENS.ACCESS_TOKEN,
      get(response, "data.data.access_token", "")
    );

    axios.defaults.headers.common["Authorization"] = `Bearer ${get(
      response,
      "data.data.access_token",
      ""
    )}`;

    // generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const registerAction = async (payload, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.registerUser(payload);

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const googleLoginAction = async (code, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.googleLogin(code);

    localStorage.setItem(
      TOKENS.REFRESH_TOKEN,
      get(response, "data.data.refresh_token", "")
    );

    axios.defaults.headers.common["Authorization"] = `Bearer ${get(
      response,
      "data.data.access_token",
      ""
    )}`;

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const logoutAction = async (userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.logoutUser();

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const refreshTokenAction = async (userOffline) => {
  if (userOffline) {
    return showToaster(
      "error",
      "You are offline, please check your internet connection"
    );
  }
  try {
    const refresh_token = localStorage.getItem(TOKENS.REFRESH_TOKEN);

    if (refresh_token === null) {
      throw new Error("Refresh token not found in local storage");
    }
    const response = await userServices.refreshToken({
      refresh_token: refresh_token,
    });
    const access_token = get(response, "data.data.access_token", "");

    localStorage.setItem(TOKENS.ACCESS_TOKEN, access_token);

    axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;

    return {
      success: true,
      id: get(response, "data.data.id", {}),
    };
  } catch (error) {
    console.log(error, "error");
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const verifyEmailAction = async (payload, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.verifyEmail(payload);

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const resendVerificationEmailAction = async (payload, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.resendVerificationEmail(payload);

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const sendOtpAction = async (payload, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.sendOtP(payload);

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const verifyOtpAction = async (payload, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.verifyOtp(payload);

    // generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const forgotPasswordAction = async (payload, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.forgotPassword(payload);

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const resetPasswordAction = async (payload, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.resetPassword(payload);

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const updateUserAction = async (payload, id, userOffline) => {
  if (userOffline) {
    return;
  }

  Object.keys(payload).forEach((key) => {
    if (payload[key] === "") {
      delete payload[key];
    }
  });
  try {
    const response = await userServices.updateUser(payload, id);

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      data: get(error, "response.data", {}),
    };
  }
};

export const updatePersonalInfoAction = async (payload, id, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.updatePersonalInfo(payload, id);

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      data: get(error, "response.data", {}),
    };
  }
};

export const updateBusinessInfoAction = async (payload, id, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.updateBusinessInfo(payload, id);

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      data: get(error, "response.data", {}),
    };
  }
};

export const updatePremiumInfoAction = async (payload, id, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.updatePremiumInfo(payload, id);

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      data: get(error, "response.data", {}),
    };
  }
};

export const initiatePaymentAction = async (payload, userOffline) => {
  if (userOffline) {
    return;
  }

  try {
    const response = await userServices.initiatePayment(payload);

    // generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      data: get(error, "response.data", {}),
    };
  }
};

export const fetchUserAction = async (id, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.fetchUser(id);

    // generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      status: get(response, "status", null),
      data: get(response, "data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      status: get(error, "response.status", null),
      data: get(error, "response.data", {}),
    };
  }
};

export const avatarUploadAction = async (file, id, userOffline) => {
  if (userOffline) {
    return;
  }

  if (!file) {
    return { success: true };
  }

  if (!file?.type?.startsWith("image/")) {
    generalHelpers.toaster("error", "Only image files are allowed");
    return { success: false };
  }

  try {
    const signedUrlResponse = await userServices.getAvatarUploadUrl(
      {
        filename: file.name,
        mimetype: file.type,
      },
      id
    );

    const signedUrl = get(signedUrlResponse, "data.data.signed_url", "");
    const key = get(signedUrlResponse, "data.data.key", "");

    if (!signedUrl || !key) {
      throw new Error("Could not retrieve upload URL");
    }

    const uploadResponse = await fetch(signedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: file,
    });

    if (!uploadResponse.ok) {
      throw new Error("Avatar upload failed");
    }

    const response = await userServices.uploadAvatarRecord(
      {
        avatar_key: key,
      },
      id
    );

    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data.user", {}),
    };
  } catch (error) {
    generalHelpers.toaster(
      "error",
      get(error, "response.data.message", error.message || "")
    );
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const fetchCustomerData = async (id, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const customerDataResponse = await userServices.fetchCustomerData(id);

    const playlists = get(customerDataResponse, "data.data.playlists", []);
    const user = get(customerDataResponse, "data.data.user", {});
    const status = get(customerDataResponse, "data.data.status", "");
    const transactions = get(
      customerDataResponse,
      "data.data.transactions",
      []
    );

    return {
      user,
      playlists,
      status,
      transactions,
    };
  } catch (error) {
    return {};
  }
};

export const doTokenRefresh = async (userOffline) => {
  if (userOffline) {
    return showToaster(
      "error",
      "You are offline, please check your internet connection"
    );
  }

  try {
    const { data } = await userServices.getNewAccessToken({
      refresh_token: localStorage.getItem(TOKENS.REFRESH_TOKEN),
    });

    const newToken = data?.data?.access_token || "";
    const id = data?.data?.id || "";

    if (isEmpty(newToken)) return false;

    localStorage.setItem(TOKENS.ACCESS_TOKEN, newToken);
    axios.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;

    return id;
  } catch (error) {
    return "";
  }
};

export const downloadInvoice = async (transactionId) => {
  try {
    // fetch the Authorization token from axios
    const token = axios.defaults.headers.common["Authorization"];
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/users/invoice/${transactionId}/download`,
      {
        method: "GET",
        headers: {
          Authorization: token,
        },
      }
    );
    
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err?.message || "Failed to download invoice");
    }
    
    const blob = await response.blob();
    return blob;
  } catch (error) {
    // Handle error
    throw error;
  }
};

// Keep old name as alias for backward compatibility
export const donwloadInvoice = downloadInvoice;

export const cancelSubscriptionAction = async () => {
  try {
    const response = await userServices.cancelSubscription();
    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const changeSubscriptionPlanAction = async (payload, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.changeSubscriptionPlan(payload);
    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const getPaymentMethodUpdateUrlAction = async (userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.getPaymentMethodUpdateUrl();
    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const fetchBillingStatusAction = async (userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.getBillingStatus();
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const fetchTransactionsAction = async (params, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.getTransactions(params);
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const resumeSubscriptionAction = async (userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.resumeSubscription();
    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};

export const cancelPendingPlanChangeAction = async (userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const response = await userServices.cancelPendingPlanChange();
    generalHelpers.toaster("success", get(response, "data.message", ""));
    return {
      success: true,
      data: get(response, "data.data", {}),
    };
  } catch (error) {
    generalHelpers.toaster("error", get(error, "response.data.message", ""));
    return {
      success: false,
      data: get(error, "response.data", {}),
    };
  }
};
